<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">Event Dashboard</h1>
    <div v-if="!data">Laddar statistik...</div>
    <div v-else class="grid gap-4 md:grid-cols-2">
      <div class="bg-white p-4 rounded shadow">
        <h2 class="text-lg font-semibold">{{ data.title }}</h2>
        <p>Totalt sålda: {{ data.totalSold }}</p>
        <p>Scannade: {{ data.scanned }}</p>
        <p>Ej scannade: {{ data.notScanned }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'EventDashboard',
  props: ['id'],
  data() {
    return { data: null };
  },
  async mounted() {
    const res = await axios.get(`/api/events/${this.id}/dashboard`, {
      headers: {
        Authorization: `Bearer ${this.$store.state.token}`
      }
    });
    this.data = res.data;
  }
};
</script>
